import { render, staticRenderFns } from "./BuildingPermissions.vue?vue&type=template&id=248148e4"
import script from "./BuildingPermissions.vue?vue&type=script&lang=js"
export * from "./BuildingPermissions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports